// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.prescription.AuthorizeEyeglassPrescriptionsRequest */
/* istanbul ignore next */
@GandalfModel
export class AuthorizeEyeglassPrescriptionsRequest extends GandalfModelBase {

	@GandalfLabel('Prescriptions')
	@GandalfValidator({ sizeArray: { min: 1, max: 2147483647, message: 'At least one prescription is required.' } })
	@GandalfValidator({ notNull: { message: 'At least one prescription is required.' } })
	@GandalfArray(Number)
	eyeglassPrescriptionIds!: number[];

	@GandalfProperty({ designType: Boolean })
	useProviderSignature!: boolean | null;

}
